import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-settings-modal-form',
  templateUrl: './settings-modal-form.component.html',
  styleUrls: ['./settings-modal-form.component.scss']
})
export class SettingsModalFormComponent implements OnInit {

  editMode: boolean = false
  form: UntypedFormGroup
  model = {}
  service: any

  /*
  model = {
    firstname: {
      type: "text",
      value: "",
      label: "FirstName",
      rules: {
        required: true,
      }
    },
    lastname: {
      type: "text",
      value: "",
      label: "LastName"
    },
    address: {
      type: "text",
      value: "",
      label: "Address",
    },
    age: {
      type: "number",
      value: "",
      label: "age"
    },
    birthDay: {
      type: "date",
      value: "",
      label: "Birthday",
    },
    typeBussines: {
      label: "Bussines Type",
      value: "premium",
      type: "radio",
      options: [
        {
          label: "Enterprise",
          value: "1500",
        },
        {
          label: "Home",
          value: "6",
        },
        {
          label: "Personal",
          value: "1",
        },
      ],

    },
    newsletterIn: {
      label: "Suscribe to newsletter",
      value: "email",
      type: "checkbox",
    },
    subscriptionType: {
      label: "Suscription Type",
      value: "premium",
      type: "select",
      options: [
        {
          label: "Pick one",
          value: "",
        },
        {
          label: "Premium",
          value: "premium",
        },
        {
          label: "Basic",
          value: "basic",
        },
      ],
    },
    country: {
      id: 'country',
      label: "Country",
      type: "select",
      options: [
        {
          label: "Spain",
          value: "ES"
        },
        {
          label: "USA",
          value: "US"
        }
      ],
      provideData: [
        {
          label: 'Barcelona',
          sourceValue: 'ES',
          value: 'BCN'
        },
        {
          label: 'Madrid',
          sourceValue: 'ES',
          value: 'MDN'
        },
        {
          label: 'New York',
          sourceValue: 'US',
          value: 'NYC'
        },
        {
          label: 'Cleveland',
          sourceValue: 'CLV',
          value: 'E'
        }
      ]

    },
    city: {
      label: "City",
      type: "select",
      link: 'country',
      value: "",
      options: [
        {
          label: "Select Country First",
          value: ""
        }
      ]
    }
  };
  */

  reasons: any = []

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SettingsModalFormComponent>,
    private fb: UntypedFormBuilder
    )
  {
    this.form = this.fb.group({
      OrderId: [null, [Validators.required]],
      ReasonId: [null, [Validators.required]],
      ReasonNotes: [null, [Validators.required]]
    })

    if(data){
     this.model = data.model
     this.service = data.service
    }


  }

  closeModal(event: any){
    console.log(event)
    if(event)  this.dialogRef.close(true);
  }

  ngOnInit(): void {
   
  }

}
